var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('lazy-image',{staticClass:"__picture_lazy",style:({'--a': (_vm.height / _vm.width).toString()}),attrs:{"src":_vm.defaultSrc,"use-picture":""}},_vm._l((_vm.sources),function(source,id){return _c('source',{key:id,attrs:{"media":source.media,"srcset":source.srcset,"type":source.type}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }